module.exports = __webpack_public_path__ + "assets/table_dark.jpg";